import React from 'react'
import Section from '../../landingPage/Section';
import IconFlipcard from "../../../components/landingPage/Flipcards/IconFlipcard";
import {Consulting, DentalLabs, GeneralPractitioners, Multidisciplinary} from '../../../images/index'


function PartnerSection() {
  const flipcards = [
    {
      id: 1,
      icon: GeneralPractitioners,
      title: "General Practitioners",
      content: "They can be the first point of care for patients and conduct initial scans & consultations with XiViX."
    },
    {
      id: 2,
      icon: Multidisciplinary,
      title: "Multidisciplinary Practice",
      content: "They can register as a XiViX CoE and perform pre-prosthetic procedures on patients."
    },
    {
      id: 3,
      icon: Consulting,
      title: "Consulting Dental Specialists",
      content: "They work at a CoE to perform precedures in the fields of Orthodontics, Parodontology, Endodontics, Implantology & Prosthodontics."
    },
    {
      id: 4,
      icon: DentalLabs,
      title: "Dental Labs",
      content: "Expert cermists here work on detailed aesthetics for the 3D models & restorations manufactured by the CIPP."
    }
  ];
  return (
    <Section title="XiViX Partners" subtitle="Our partners may look like," id="Partner" className="py-8 md:py-12 ">
      <div className="grid grid-cols-1 mt-8 sm:grid-cols-2 lg:gap-8 lg:max-w-max xl:grid-cols-4 place-items-center mx-auto">
      {flipcards.map(flipcard => {
        return (
          <IconFlipcard flipcard={flipcard} key={flipcard.id}/>
        )
      })}
    </div>
  
    </Section>
  )
}

export default PartnerSection;